export default  {
    bindings: {
        period: '<',
        formTab: '='
    },
    controller: 'pricingFormController',
    template: require('../views/pricing.form.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/period/components/pricing.form.component.js